import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapFileName'
})
export class MapFileNamePïpe implements PipeTransform {

  transform(t: string): string {

    let res = '';

    if (t.includes('.jpg')){
        res = "jpg"
    }
    if (t.includes('.JPG')) {
      res = "jpg"
    }

    if (t.includes('.png')){
        res = "png"
    }

    if (t.includes('.mp4')){
        res = "video"
    }



    
    // switch (
    // t
    // ) {
    //   case "folder":
    //     res = "folder";
    //     break;

    //   case "pdf":
    //     res = "picture_as_pdf";
    //     break;

    //   case "file":
    //     res = "insert_photo";
    //     break;

    //   case "quiz":
    //     res = "assignment";
    //     break;

    //   case "web":
    //     res = "http";
    //     break;

    //     case "file":
    //       res = "Fichier";
    //       break;

    //   default:
    //     break;
    // }

    return res;
  }


}
